export const FETCH_POLICY_NETWORK_ONLY = 'network-only';
